const normalizeLocale = (language) => (
    String(language || "").toLowerCase().startsWith("fr") ? "fr" : "en"
);

const pickTranslation = (translations, locale, field) => {
    const key = field === "title" ? "label" : field;
    return (
        translations?.[locale]?.[key] ||
        translations?.fr?.[key] ||
        translations?.en?.[key] ||
        undefined
    );
};

export function resolveCriterionText(criterion, language) {
    const locale = normalizeLocale(language);
    const translations = criterion?.translations || {};

    return {
        title: pickTranslation(translations, locale, "title") || criterion?.title || "",
        description: pickTranslation(translations, locale, "description") || criterion?.description || "",
        section: pickTranslation(translations, locale, "section") || criterion?.section || "",
    };
}
